const gmpConstants = gmp_constants;
const gmpSettings = gmp_settings;
let marketingCards = [];
// Not available on all pages
if (typeof marketing_cards === "object" && Array.isArray(marketing_cards)) {
  marketingCards = marketing_cards;
  for (const card of marketingCards) {
    if (card.link === "") card.link = undefined;
    if (card.link && card.link.target === "") card.link.target = undefined;
    if (card.link && card.link.url === "") card.link.url = undefined;
    if (card.link && card.link.title === "") card.link.title = undefined;
    if (card.image === "") card.image = undefined;
  }
}

let environmentConstants;
if (gmpConstants && gmpConstants.dev_mode === "0") {
  // PRODUCTION constants
  environmentConstants = {
    DevMode: false,
    GmpApiURL: "https://api.greenmountainpower.com/api/v2",
    HomePageURL: "/",
    BillReportURL: "https://billreport.greenmountainpower.com",
    RecurringPaymentsURL: "https://paynow40.speedpay.com/GreenMountainPower/postinit.aspx",
    OutageURL: "https://outages.greenmountainpower.com",
    StatusURL: "https://greenmountainpower.statuspage.io/api/v2",
  };
} else {
  // DEV constants
  environmentConstants = {
    DevMode: true,
    GmpApiURL: "https://apitst.greenmountainpower.com/api/v2",
    HomePageURL: "/",
    BillReportURL: "https://billreportdev.greenmountainpower.com",
    RecurringPaymentsURL: "https://sptest34a.speedpay.com/Greenmountain/postinit.aspx",
    OutageURL: "https://outagestst.greenmountainpower.com",
    StatusURL: "https://gmpstaging.statuspage.io/api/v2",
  };
}

console.log((environmentConstants.DevMode ? "Development" : "Production") + " mode");

export const EnvironmentConstants = environmentConstants;

export const GMPPhoneNumber = gmpSettings.phone_number;

export const GMPEmail = gmpSettings.email_address;

export const MarketingCards = marketingCards;

export const DefaultChatQueue = "MYACCOUNT";